<template>
  <div class="rbu-item-editor">
    <RbuItemModuleGroup
      v-for="(group, groupIdx) in groups"
      :key="groupIdx"
      :group="group"
      :idx="groupIdx"
      @update="onGroupUpdate(groupIdx, $event)"
      @delete="removeGroup(groupIdx)"
    ></RbuItemModuleGroup>
    <v-card-actions>
      <v-btn color="primary" outlined @click="addGroup">Add Group </v-btn>
    </v-card-actions>

    <div class="rbu-item-summary">
      <div class="rbu-item-summary-header">Item Summary</div>
      <div class="rbu-item-summary-content">
        <div class="rbu-item-summary-table-wrapper">
          <div class="rbu-item-summary-table">
            <div
              class="rbu-item-summary-table-header rbu-item-summary-table-row"
            >
              <div class="rbu-item-summary-table-row-column-1"></div>
              <div class="rbu-item-summary-table-row-column-2"></div>
              <div class="rbu-item-summary-table-row-column-value">Price</div>
              <div class="rbu-item-summary-table-row-column-multiplier">
                Multiplier
              </div>
              <div class="rbu-item-summary-table-row-column-formula">
                Formula
              </div>
              <div class="rbu-item-summary-table-row-column-descriptions">
                Descriptions
              </div>
              <div class="rbu-item-summary-table-row-column-actions"></div>
            </div>
            <div v-for="(group, idx) in groups" :key="idx">
              <RbuItemSummaryRow
                :group="group"
                :idx="idx"
                @update="onSummaryGroupUpdate(idx, $event)"
              ></RbuItemSummaryRow>
            </div>
            <div class="rbu-item-summary-table-row" v-if="groups.length > 1">
              <div class="rbu-item-summary-table-row-column-1"></div>
              <div
                class="rbu-item-summary-table-row-column-2"
                style="display: flex; align-self: center"
              >
                <div class="d-flex align-center">
                  <label class="flex-grow-1">Total </label>
                  <v-select
                    outlined
                    dense
                    hide-details
                    attach
                    :items="moduleGroupValueModeOptions"
                    :value="item.module_group_value_mode"
                    @input="onUpdate({ module_group_value_mode: $event })"
                    style="flex: 0 0 150px"
                  ></v-select>
                </div>
              </div>
              <div
                class="rbu-item-summary-table-row-column-value d-flex align-center"
              >
                {{ $parseCurrency(compAfterSummaryGroupTotalFormula) }}
              </div>
              <div class="rbu-item-summary-table-row-column-multiplier"></div>
              <div class="rbu-item-summary-table-row-column-formula">
                <!-- formula -->
                <div
                  class="flex"
                  style="
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    gap: 5px;
                  "
                >
                  <v-textarea
                    outlined
                    auto-grow
                    rows="1"
                    dense
                    hide-details
                    :value="summaryGroupTotalFormulaPrefix"
                    @input="
                      onSummaryGroupTotalFormulaUpdate(
                        $event,
                        summaryGroupTotalFormulaSuffix
                      )
                    "
                  ></v-textarea>

                  <div class="rbu-rate-box">
                    {{ item.module_group_value_mode === "SUM" ? "Sum" : "Avg" }}
                    <br />({{ $parseCurrency(compBeforeAdjustments) }})
                    <!-- <br />({{ $parseCurrency(beforeAdjustmentsNoFormula) }}) -->
                  </div>

                  <v-textarea
                    outlined
                    dense
                    hide-details
                    auto-grow
                    rows="1"
                    :value="summaryGroupTotalFormulaSuffix"
                    @input="
                      onSummaryGroupTotalFormulaUpdate(
                        summaryGroupTotalFormulaPrefix,
                        $event
                      )
                    "
                  ></v-textarea>
                </div>
              </div>
              <div
                class="rbu-item-summary-table-row-column-descriptions"
                style="display: flex; align-self: center"
              >
                <!-- desc -->
                <v-textarea
                  outlined
                  auto-grow
                  rows="1"
                  dense
                  hide-details
                  placeholder="Description"
                  :value="item.module_group_summary_description"
                  @input="
                    onUpdate({ module_group_summary_description: $event })
                  "
                ></v-textarea>
              </div>
              <div class="rbu-item-summary-table-row-column-actions"></div>
            </div>

            <!-- Overhead -->
            <div class="rbu-item-summary-table-row">
              <div class="rbu-item-summary-table-row-column-1">
                Overhead &amp; Profit
              </div>
              <div class="rbu-item-summary-table-row-column-2">
                <div>
                  <span
                    >{{ $t("rbu.head_office_overhead_and_profit") }} (+{{
                      overhead
                    }}%)</span
                  >
                </div>
              </div>
              <div class="rbu-item-summary-table-row-column-value"></div>
              <div class="rbu-item-summary-table-row-column-multiplier">
                {{
                  Math.round(floatingPointFix((overhead + 100) * 100)) / 100
                }}%
              </div>
              <div class="rbu-item-summary-table-row-column-formula">
                <!-- <v-text-field
                  number
                  outlined
                  dense
                  :value="item.head_office_overhead_and_profit"
                  @input="onUpdate({ head_office_overhead_and_profit: $event })"
                >
                </v-text-field> -->
              </div>
              <div class="rbu-item-summary-table-row-column-descriptions"></div>
              <div class="rbu-item-summary-table-row-column-actions"></div>
            </div>

            <!-- Adjustment -->
            <div
              class="rbu-item-summary-table-row no-border"
              v-if="item.adjustment_value_first"
            >
              <div class="rbu-item-summary-table-row-column-1">Adjustment</div>
              <div class="rbu-item-summary-table-row-column-2">
                Adjustment in $
              </div>
              <div class="rbu-item-summary-table-row-column-3"></div>
              <div
                class="rbu-item-summary-table-row-column-value d-flex align-center"
              >
                {{ $parseCurrency(item.adjustment_value) }}
              </div>
              <div class="rbu-item-summary-table-row-column-multiplier"></div>
              <div class="rbu-item-summary-table-row-column-formula">
                <v-textarea
                  outlined
                  dense
                  hide-details
                  placeholder="Formula"
                  auto-grow
                  rows="1"
                  clearable
                  :value="item.adjustment_value_formula"
                  @input="onAdjustmentValueFormulaUpdate"
                ></v-textarea>
              </div>
              <div class="rbu-item-summary-table-row-column-descriptions">
                <v-textarea
                  outlined
                  auto-grow
                  rows="1"
                  dense
                  hide-details
                  placeholder="Description"
                  :value="item.adjustment_value_descriptions"
                  @input="onUpdate({ adjustment_value_descriptions: $event })"
                ></v-textarea>
              </div>
              <div class="rbu-item-summary-table-row-column-actions">
                <v-btn
                  icon
                  color="primary"
                  @click="
                    onUpdate({
                      adjustment_value_first: !item.adjustment_value_first,
                    })
                  "
                >
                  <v-icon>mdi-swap-vertical</v-icon>
                </v-btn>
              </div>
            </div>
            <div
              :class="[
                'rbu-item-summary-table-row',
                { 'no-border': !item.adjustment_value_first },
              ]"
            >
              <div class="rbu-item-summary-table-row-column-1">
                <span v-if="!item.adjustment_value_first">Adjustment</span>
              </div>
              <div class="rbu-item-summary-table-row-column-2">
                Adjustment in %
                {{
                  item.adjustment_percentage
                    ? `(${(
                        parseFloat(item.adjustment_percentage) - 100
                      ).toFixed(2)}%)`
                    : ""
                }}
              </div>
              <div class="rbu-item-summary-table-row-column-3"></div>
              <div class="rbu-item-summary-table-row-column-value"></div>
              <div
                class="rbu-item-summary-table-row-column-multiplier d-flex align-center"
              >
                {{ item.adjustment_percentage }}%
              </div>
              <div class="rbu-item-summary-table-row-column-formula">
                <v-textarea
                  outlined
                  dense
                  hide-details
                  placeholder="100"
                  auto-grow
                  rows="1"
                  clearable
                  :value="item.adjustment_percentage_formula"
                  @input="onAdjustmentPercentageFormulaUpdate"
                ></v-textarea>
              </div>
              <div class="rbu-item-summary-table-row-column-descriptions">
                <v-textarea
                  outlined
                  auto-grow
                  rows="1"
                  dense
                  hide-details
                  placeholder="Description"
                  :value="item.adjustment_percentage_descriptions"
                  @input="
                    onUpdate({ adjustment_percentage_descriptions: $event })
                  "
                ></v-textarea>
              </div>
              <div class="rbu-item-summary-table-row-column-actions">
                <v-btn
                  icon
                  color="primary"
                  @click="
                    onUpdate({
                      adjustment_value_first: !item.adjustment_value_first,
                    })
                  "
                >
                  <v-icon>mdi-swap-vertical</v-icon>
                </v-btn>
              </div>
            </div>
            <div
              class="rbu-item-summary-table-row"
              v-if="!item.adjustment_value_first"
            >
              <div class="rbu-item-summary-table-row-column-1"></div>
              <div class="rbu-item-summary-table-row-column-2">
                Adjustment in $
              </div>
              <div class="rbu-item-summary-table-row-column-3"></div>
              <div
                class="rbu-item-summary-table-row-column-value d-flex align-center"
              >
                {{ $parseCurrency(item.adjustment_value) }}
              </div>
              <div class="rbu-item-summary-table-row-column-multiplier"></div>
              <div class="rbu-item-summary-table-row-column-formula">
                <v-textarea
                  outlined
                  dense
                  hide-details
                  placeholder="Formula"
                  auto-grow
                  rows="1"
                  clearable
                  :value="item.adjustment_value_formula"
                  @input="onAdjustmentValueFormulaUpdate"
                ></v-textarea>
              </div>
              <div class="rbu-item-summary-table-row-column-descriptions">
                <v-textarea
                  outlined
                  auto-grow
                  rows="1"
                  dense
                  hide-details
                  placeholder="Description"
                  :value="item.adjustment_value_descriptions"
                  @input="onUpdate({ adjustment_value_descriptions: $event })"
                ></v-textarea>
              </div>
              <div class="rbu-item-summary-table-row-column-actions">
                <v-btn
                  icon
                  color="primary"
                  @click="
                    onUpdate({
                      adjustment_value_first: !item.adjustment_value_first,
                    })
                  "
                >
                  <v-icon>mdi-swap-vertical</v-icon>
                </v-btn>
              </div>
            </div>

            <!-- Sub Total -->
            <div class="rbu-item-summary-table-row no-border">
              <div class="rbu-item-summary-table-row-column-1"></div>
              <div class="rbu-item-summary-table-row-column-2 text-right">
                Total
              </div>
              <div class="rbu-item-summary-table-row-column-value">
                <b>{{ $parseCurrency(item.calculated_rate) }}</b>
              </div>
              <div class="rbu-item-summary-table-row-column-multiplier"></div>
              <div class="rbu-item-summary-table-row-column-formula"></div>
              <div class="rbu-item-summary-table-row-column-descriptions"></div>
              <div class="rbu-item-summary-table-row-column-actions"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, provide, ref, watch } from "@vue/composition-api";
import RbuItemModuleGroup from "@/components/rbu/RbuItemModuleGroup.vue";
import RbuItemSummaryRow from "@/components/rbu/RbuItemSummaryRow.vue";
import { RBU_MODULE_GROUP_VALUE_MODE } from "@/constants";
import floatingPointFix from "js-floating-point";

export default {
  name: "RbuItemEditor",
  components: { RbuItemModuleGroup, RbuItemSummaryRow },
  props: {
    item: Object,
  },
  setup(props, { emit }) {
    provide("RBU_ITEM", props.item);
    provide(
      "RBU_EDITION_LATEST",
      computed(() => props.item.section.edition.latest)
    );
    provide(
      "RBU_EDITION_BASE_START",
      computed(() => props.item.section.edition.base_start)
    );
    provide(
      "RBU_EDITION_BASE_END",
      computed(() => props.item.section.edition.base_end)
    );

    const summaryGroupTotalFormulaPrefix = computed(() => {
      const components = (props.item.module_group_summary_formula || "").split(
        "{{value}}"
      );

      if (components.length === 2) {
        return components[0];
      }
      return "";
    });
    const summaryGroupTotalFormulaSuffix = computed(() => {
      const components = (props.item.module_group_summary_formula || "").split(
        "{{value}}"
      );

      if (components.length === 2) {
        return components[1];
      }
      return "";
    });

    // onSummaryGroupTotalFormulaUpdate
    const onSummaryGroupTotalFormulaUpdate = function (prefix, suffix) {
      onUpdate({ module_group_summary_formula: `${prefix}{{value}}${suffix}` });
    };

    const isCustomConfig = computed(() => {
      return props.item.custom_head_office_overhead_and_profit;
      // let result = false;
      // if (
      //   props.item.section &&
      //   props.item.section.edition.head_office_overhead_and_profit
      // ) {
      //   const edition_overhead =
      //     Math.round(
      //       floatingPointFix(
      //         parseFloat(
      //           props.item.section.edition.head_office_overhead_and_profit
      //         )
      //       ) * 100
      //     ) / 100;
      //   const self_overhead =
      //     Math.round(
      //       floatingPointFix(
      //         parseFloat(props.item.head_office_overhead_and_profit || 0)
      //       ) * 100
      //     ) / 100;

      //   if (edition_overhead === self_overhead) {
      //     result = true;
      //   }
      // }

      // return result;
    });

    const groups = ref([]);
    const addGroup = function () {
      groups.value.push({
        order_no: groups.value.length,
        ignored: false,
        modules: [],
      });

      onUpdate({ module_groups: groups.value });
    };
    const onGroupUpdate = function (groupIdx, m) {
      groups.value.splice(groupIdx, 1, m);

      onUpdate({ module_groups: groups.value });
    };

    const onSummaryGroupUpdate = function (groupIdx, m) {
      let total = 0;
      let groupModules = groups.value[groupIdx].modules;
      groupModules.forEach((g) => {
        if (!g.ignored) {
          total = floatingPointFix(total + (parseFloat(g.sub_total) || 0));
        }
      });

      if (m.group_formula) {
        try {
          if (m.group_formula.includes("{{value}}")) {
            const formula = m.group_formula.replaceAll("{{value}}", total);
            total = floatingPointFix(eval(formula));
          } else {
            const formula = total + m.group_formula;
            total = floatingPointFix(eval(formula));
          }
        } catch (e) {
          console.log(e);
        }
      }

      total = Math.round(floatingPointFix(total * 100)) / 100;

      groups.value[groupIdx] = {
        ...groups.value[groupIdx],
        ...m,
        calculated_sub_total: total,
      };

      onUpdate({ module_groups: groups.value });

      // get group by index
      // groups.value.splice(groupIdx, 1);
      // onUpdate({ module_groups: groups.value });
    };

    const removeGroup = function (groupIdx) {
      groups.value.splice(groupIdx, 1);

      onUpdate({ module_groups: groups.value });
    };
    const moduleGroupValueModeOptions = computed(() => {
      return [
        { text: "Average", value: RBU_MODULE_GROUP_VALUE_MODE.AVERAGE },
        { text: "Sum", value: RBU_MODULE_GROUP_VALUE_MODE.SUM },
      ];
    });

    const overhead = computed(() => {
      if (props.item.head_office_overhead_and_profit) {
        return (
          Math.round(
            floatingPointFix(
              parseFloat(props.item.head_office_overhead_and_profit) * 100
            )
          ) / 100
        );
      }
      return 0;
    });

    const edition_overhead = computed(() => {
      if (
        props.item.section &&
        props.item.section.edition.head_office_overhead_and_profit
      ) {
        return (
          Math.round(
            floatingPointFix(
              parseFloat(
                props.item.section.edition.head_office_overhead_and_profit
              ) * 100
            )
          ) / 100
        );
      }
      return 0;
    });

    const beforeAdjustments = function (i) {
      const item = i || props.item;
      const moduleGroups = item.module_groups || [];

      let total = 0;

      moduleGroups.forEach((g) => {
        if (!g.ignored) {
          total = floatingPointFix(
            total + parseFloat(g.calculated_sub_total) || 0
          );
        }
      });

      const active_group = moduleGroups.filter((g) => !g.ignored);

      if (
        i.module_group_value_mode === RBU_MODULE_GROUP_VALUE_MODE.AVERAGE &&
        active_group.length > 0
      ) {
        total = floatingPointFix(total / active_group.length);
      }

      total = Math.round(floatingPointFix(total * 100)) / 100;

      return total;
    };

    const afterAdjustments = function (i) {
      const item = i || props.item;
      let sub_total = beforeAdjustments(item);
      if (item.module_group_summary_formula) {
        let value = sub_total;
        try {
          let formula = item.module_group_summary_formula.replace(
            "{{value}}",
            value
          );
          value = floatingPointFix(eval(formula));
          value = Math.round(floatingPointFix(parseFloat(value) * 100)) / 100;
        } catch (e) {
          console.debug(e);
        }
        sub_total = value;
      }

      if (item.head_office_overhead_and_profit) {
        let o = floatingPointFix(
          parseFloat(item.head_office_overhead_and_profit) / 100 + 1
        );
        o = Math.round(floatingPointFix(o * 10000)) / 10000;
        sub_total = floatingPointFix(sub_total * o);
      }

      function applyValueAdjustment() {
        if (item.adjustment_value && parseFloat(item.adjustment_value)) {
          sub_total = floatingPointFix(
            sub_total + parseFloat(item.adjustment_value)
          );
        }
      }

      function applyPercentageAdjustment() {
        if (
          item.adjustment_percentage &&
          parseFloat(item.adjustment_percentage)
        ) {
          sub_total = floatingPointFix(
            (sub_total * parseFloat(item.adjustment_percentage)) / 100
          );
        }
      }

      if (item.adjustment_value_first) {
        applyValueAdjustment();
        applyPercentageAdjustment();
      } else {
        applyPercentageAdjustment();
        applyValueAdjustment();
      }

      // return Math.ceil(fixNumber(sub_total) * 100) / 100;
      return Math.round(floatingPointFix(sub_total * 100)) / 100;
    };

    const onAdjustmentValueFormulaUpdate = function (evt) {
      console.debug("onAdjustmentValueFormulaUpdate", evt);

      let value;

      if (evt) {
        try {
          value = floatingPointFix(eval(evt));
        } catch (e) {
          value = 0;
          console.debug(e);
        }
      } else {
        value = 0;
      }

      value = Math.round(floatingPointFix(parseFloat(value) * 100)) / 100;

      onUpdate({
        adjustment_value: value,
        adjustment_value_formula: evt,
      });
    };

    const onAdjustmentPercentageFormulaUpdate = function (evt) {
      console.debug("onAdjustmentPercentageFormulaUpdate", evt);

      let value;

      if (evt) {
        try {
          value = floatingPointFix(eval(evt));
        } catch (e) {
          value = 0;
          console.debug(e);
        }
      } else {
        value = 100;
      }

      value = Math.round(floatingPointFix(parseFloat(value) * 100)) / 100;

      onUpdate({
        adjustment_percentage: value,
        adjustment_percentage_formula: evt,
      });
    };

    const onUpdate = function (evt) {
      console.debug("Item Update: ", evt);

      let updates = {
        ...props.item,
        ...evt,
      };

      updates.beforeAdjustments = beforeAdjustments(updates);
      updates.calculated_rate = afterAdjustments(updates);

      emit("update", updates);
    };

    watch(
      () => props.item,
      (newValue) => {
        groups.value = newValue.module_groups;

        if (groups.value.length === 0) {
          addGroup();
        }
      },
      { immediate: true }
    );

    const compBeforeAdjustments = computed(() => {
      return beforeAdjustments(props.item);
    });

    const compAfterSummaryGroupTotalFormula = computed(() => {
      if (props.item.module_group_summary_formula) {
        let value = compBeforeAdjustments.value;
        try {
          let formula = props.item.module_group_summary_formula.replace(
            "{{value}}",
            value
          );
          value = floatingPointFix(eval(formula));
          value = Math.round(floatingPointFix(parseFloat(value) * 100)) / 100;
        } catch (e) {
          console.debug(e);
        }
        return value;
      } else {
        return compBeforeAdjustments.value;
      }
    });

    return {
      groups,
      addGroup,
      onGroupUpdate,
      removeGroup,
      moduleGroupValueModeOptions,
      overhead,
      edition_overhead,
      onAdjustmentValueFormulaUpdate,
      onAdjustmentPercentageFormulaUpdate,
      onUpdate,
      onSummaryGroupUpdate,
      compBeforeAdjustments,
      isCustomConfig,
      summaryGroupTotalFormulaPrefix,
      summaryGroupTotalFormulaSuffix,
      onSummaryGroupTotalFormulaUpdate,
      compAfterSummaryGroupTotalFormula,
      floatingPointFix,
    };
  },
};
</script>

<style lang="less">
.rbu-item-editor {
  margin-top: 12px;

  .rbu-item-summary {
    padding: 16px;
    background: rgba(0, 0, 0, 0.03);

    .rbu-item-summary-header {
      font-weight: bold;
    }

    .rbu-item-summary-content {
      display: flex;
      flex-direction: column;
      padding: 8px 0;

      .rbu-item-summary-table-wrapper {
        overflow: auto;

        .rbu-item-summary-table {
          display: flex;
          gap: 16px;
          flex-direction: column;
          background: rgba(255, 255, 255, 0.5);

          .rbu-item-summary-table-header {
            background: rgba(0, 0, 0, 0.06) !important;
            font-size: 75%;
            color: rgba(0, 0, 0, 0.4);
          }

          .rbu-item-summary-table-row {
            min-width: 1816px;
            flex: 1 1 auto;

            display: flex;
            gap: 8px;
            border-bottom: solid 1px rgba(0, 0, 0, 0.06);
            padding: 8px 0;

            &.no-border {
              border-bottom: none !important;
            }
          }

          .rbu-item-summary-table-row-column-1 {
            flex: 0 0 80px;
            color: rgba(0, 0, 0, 0.4);
            font-size: 75%;
          }

          .rbu-item-summary-table-row-column-2 {
            flex: 0 0 400px;
          }

          .rbu-item-summary-table-row-column-value {
            flex: 0 0 150px;
          }

          .rbu-item-summary-table-row-column-multiplier {
            flex: 0 0 100px;
          }

          .rbu-item-summary-table-row-column-formula {
            flex: 0 0 300px;
          }

          .rbu-item-summary-table-row-column-descriptions {
            flex: 0 0 500px;
          }

          .rbu-item-summary-table-row-column-actions {
            flex: 0 0 200px;

            display: flex;

            .ignore-checkbox {
              i,
              label {
                color: var(--v-primary-base);
              }
            }
          }
        }
      }
    }
  }
}
</style>
